import styled from 'styled-components'

const Form = styled.form``

export default Form
